<template>
  <div class="redemption-log-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-input placeholder="请输入渠道号" v-model="params.channel" clearable size="small" @keyup.enter.native="redemptionLogList('status')" class="param-input"></el-input>
      <el-input placeholder="请输入兑换码" v-model="params.code" clearable size="small" @keyup.enter.native="redemptionLogList('status')" class="param-input"></el-input>
      <el-input placeholder="请输入兑换者" v-model.number="params.userID" clearable size="small" @keyup.enter.native="redemptionLogList('status')" class="param-input"></el-input>
      <el-select v-model="params.authority" size="small" placeholder="兑换权限" clearable @change="redemptionLogList('status')">
        <el-option v-for="item in authorityList" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="redemptionLogList('status')">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="code" label="兑换码" align="center" :show-overflow-tooltip="true" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.code || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userID" label="兑换者" align="center" :show-overflow-tooltip="true" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.userID || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="channel" min-width="160" label="所属渠道" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span> {{scope.row.channel  | channelRule}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="authority" label="兑换权限" align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{scope.row.authority  | authorityRule}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reward" label="兑换量" align="center" min-width="150">
        <template slot-scope="scope">
          <span> {{scope.row.reward  | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="220">
        <template slot-scope="scope">
          <span> {{scope.row.createdAt  | changeDate}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5,10,15,20]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" background @size-change="changeSize" :total="total" v-if="total > 10" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import API from '@/api'
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: '',
      // 兑换日志列表参数
      params: {
        code: '',
        userID: '',
        channel: '',
        authority: '',
        pageNumber: 1,
        pageSize: 10,
      },
      authorityList: [
        {
          label: '兑换VIP',
          value: 'shortVideoVip'
        },
        // {
        //   label: '影视VIP',
        //   value: 'filmVip'
        // },
        // {
        //   label: '超级VIP',
        //   value: 'superVip'
        // },
        {
          label: '兑换金币',
          value: 'gold'
        },
      ],
    }
  },
  filters: {
    channelRule(val) {
      if (val instanceof Array) {
        return val.join(',')
      }
      return val
    },
    authorityRule(val) {
      const ruleObj = {
        // shortVideoVip: '短视频VIP',
        // filmVip: '影视VIP',
        // superVip: '超级VIP',
        shortVideoVip:'兑换VIP',
        gold: '兑换金币',
      }
      return ruleObj[val] || '未知'
    },
  },
  created() {
    this.redemptionLogList()
  },
  methods: {
    // 请求兑换日志列表
    redemptionLogList() {
      this.loading = true
      API.redemptionLogList(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.loading = false
      })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size
      this.params.pageNumber = 1
      this.redemptionLogList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.redemptionLogList()
    },
  }
}
</script>
<style scoped>
</style>
